import Vue from 'vue'
import $ from 'jQuery'
import _ from 'lodash'
import store from '@/store'

export default {

  // fn: scroll to the top of the DOM
  scrollTop () {
    // immediate
    window.scrollTo(0, 0)

    // dom settle
    Vue.nextTick(() => {
      // once more
      window.scrollTo(0, 0)

      // timeout
      window.setTimeout(() => {
        // last time
        window.scrollTo(0, 0)
      })
    })
  },

  // fn: bind click event to the document
  bindClick (options, callback) {
    $(options.css).on('click.' + options.namespace, callback)
  },

  // fn: unbind document click event
  unbindClick (options) {
    $(options.css).off('click.' + options.namespace)
  },

  // fn: focus the css w/in options
  focus (options) {
    window.setTimeout(() => {
      $(options.css).focus()
    }, options.hold || 0)
  },

  // fn: set favicon to config favicon value
  setFavicon () {
    // if store config has a agency favicon
    if (_.isObject(store.getters.config) && _.isObject(store.getters.config.agency)) {
      // apply agency favicon as elements href
      $('#favicon').attr('href', store.getters.config.agency.favicon)
    }
  },

  // fn: on window resize
  onResize: function ({ namespace, debounce, callback }) {
    // namespace so we can destroy later & debounce so the event doesn't fire too frequently
    $(window).on('resize.' + namespace, _.debounce(() => {
      callback()
    }, debounce))

    // return a fn that destroys this event
    return () => {
      $(window).off('resize.' + namespace)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/$glDom.js